import Home from '@/views/sys/home/Home.vue'
import Privilege from '@/views/sys/privilege/Privilege.vue'
import Admin from '@/views/sys/admin/Admin.vue'
import Role from '@/views/sys/role/Role.vue'
import SysLog from '@/views/sys/sys-log/SysLog.vue'
import MediaAccount from '@/views/sys/media-account/MediaAccount.vue'
import Corporation from '@/views/sys/corporation/Corporation.vue'
import Worker from '@/views/sys/worker/Worker.vue'
import Advertiser from '@/views/sys/advertiser/Advertiser.vue'
import LocalMaterial from '@/views/sys/local-material/LocalMaterial.vue'
import Team from '@/views/sys/team/Team.vue'
import TitleGroup from '@/views/sys/title-group/TitleGroup.vue'
import AdTask from '@/views/sys/ad-task/AdTask.vue'
import MediaProjectCloseTask from '@/views/sys/media-project-close-task/MediaProjectCloseTask.vue'
import MediaAdvertiserStat from '@/views/sys/media-advertiser-stat/MediaAdvertiserStat.vue'
import KsSeriesAuthorization from '@/views/sys/ks-series-authorization/KsSeriesAuthorization.vue'

// 说明：路由仅保留超级管理员权限（role_id=1）中配置的页面
const routes = [
    { path: '/', name: 'home', component: Home, meta: { title: '首页', auth: true } },
    { path: '/privileges', name: 'privileges', component: Privilege, meta: { title: '权限列表', auth: true } },
    { path: '/admins', name: 'admins', component: Admin, meta: { title: '管理员列表', auth: true } },
    { path: '/roles', name: 'roles', component: Role, meta: { title: '角色列表', auth: true } },
    { path: '/sys-logs', name: 'sys_logs', component: SysLog, meta: { title: '操作日志', auth: true } },
    { path: '/media-accounts', name: 'media_accounts', component: MediaAccount, meta: { title: '授权账号列表', auth: true } },
    { path: '/corporations', name: 'corporations', component: Corporation, meta: { title: '主体列表', auth: true } },
    { path: '/workers', name: 'workers', component: Worker, meta: { title: '优化师列表', auth: true } },
    { path: '/advertisers/kuaishou', name: 'ks_advertisers', component: Advertiser, meta: { title: '快手广告', auth: true } },
    { path: '/local-materials', name: 'local_materials', component: LocalMaterial, meta: { title: '本地素材列表', auth: true } },
    { path: '/teams', name: 'teams', component: Team, meta: { title: '小组列表', auth: true } },
    { path: '/title-groups', name: 'title_group', component: TitleGroup, meta: { title: '本地文案库列表', auth: true } },
    { path: '/tasks/kuaishou', name: 'kuaishou_tasks', component: AdTask, meta: { title: '快手任务', auth: true } },
    { path: '/media-project-close-task', name: 'media_project_close_tasks', component: MediaProjectCloseTask, meta: { title: '关停任务', auth: true } },
    { path: '/media-advertiser-stats', name: 'media_advertiser_stats', component: MediaAdvertiserStat, meta: { title: '广告主报表[快手]', auth: true } },
    { path: '/ks-series-authorizations', name: 'ks_series_authorizations', component: KsSeriesAuthorization, meta: { title: '短剧经营者', auth: true } },
]

export default routes
